import React, { useEffect, useState } from "react";
import Contenido from './components/Contenido'

export default function NuevaSolicitud() {
  const [nuevosComprobantes, setNuevosComprobantes] = useState([]);

  function getNuevosComprobantes() {
    return nuevosComprobantes;
  }

  useEffect(() => {
    const nuevosComprobantesData = getNuevosComprobantes()
    setNuevosComprobantes(nuevosComprobantesData)
  }, []);

  const handleNuevosComprobantes = (nc) => {
    // Descomentar esto cuando se implementen más comprobantes
    //   if (nc?.esNuevo)
    //     setNuevosComprobantes([...nuevosComprobantes, nc])
    //   else {
    //     const copia = [...nuevosComprobantes];
    //     copia[nc.indice] = nc;
    //     console.log(copia)
    //     setNuevosComprobantes(copia);
    //   }

    setNuevosComprobantes([nc])
  }

  return (
    <Contenido data={nuevosComprobantes} onSetNuevosComprobantes={handleNuevosComprobantes} />
  )

}